import Logger from '../../functions/logging';

class GoogleAnalyticsCore {
	constructor() {
		this.className = 'GoogleAnalyticsCore';
	}

	dispatchEvent(data) {
		Logger.log(this.constructor.name, ': event dispatched', data);

		let eventSet = data.gaEventSet;
		data.gaTracker.event({ category: eventSet.category, action: eventSet.action, label: eventSet.label });
	}
}

export default GoogleAnalyticsCore;


// WEBPACK FOOTER //
// ./src/analytics/google-analytics-adapter/GoogleAnalyticsCore.js